import { useEffect, useState } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { mapBoat } from "./mapBoat";
import { withIdConverter } from "@poseidon/firebase/converters/with-id";

export const useBoat = (boatId) => {
  const [boat, setBoat] = useState();
  const [value, loading, error] = useDocument(doc(db, "boats", boatId), {
    snapshotListenOptions: { includeMetadataChanges: true },
  });
  const [application, loadingApp, errorApp] = useDocument(
    value?.get("application")?.withConverter(withIdConverter),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  useEffect(() => {
    const run = async () => {
      if (value) {
        const boat = await mapBoat(value);
        setBoat({ ...boat, application: application?.data() });
      }
    };
    run();
  }, [value, application]);

  return { boat, loading: loading || loadingApp, error: error || errorApp };
};
